module.exports = __webpack_public_path__ + "static/img/7.3952284e.jpeg";